import { render, staticRenderFns } from "./Affiliates.vue?vue&type=template&id=f66e787c&scoped=true&"
import script from "./Affiliates.vue?vue&type=script&lang=js&"
export * from "./Affiliates.vue?vue&type=script&lang=js&"
import style0 from "./Affiliates.vue?vue&type=style&index=0&id=f66e787c&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66e787c",
  null
  
)

export default component.exports